import { baseAPI } from '~/shared/api/base-api';
import type {
  RecitalVolunteer,
  CreateVolunteerDto,
  UpdateVolunteerDto,
  VolunteerQueryParams,
} from '../model/types/volunteers';

export const volunteersApi = {
  // Create volunteer signup (parent-facing)
  create: async (
    recitalId: string,
    data: CreateVolunteerDto
  ): Promise<RecitalVolunteer> => {
    const response = await baseAPI.post(
      `/recitals/${recitalId}/volunteers`,
      data
    );
    return response.data;
  },

  // List all volunteers for a recital (admin-facing)
  list: async (
    recitalId: string,
    params?: VolunteerQueryParams
  ): Promise<RecitalVolunteer[]> => {
    const response = await baseAPI.get(
      `/recitals/${recitalId}/volunteers`,
      { params }
    );
    return response.data;
  },

  // Get volunteer details
  getOne: async (volunteerId: string): Promise<RecitalVolunteer> => {
    const response = await baseAPI.get(
      `/volunteers/${volunteerId}`
    );
    return response.data;
  },

  // Update volunteer
  update: async (
    volunteerId: string,
    data: UpdateVolunteerDto
  ): Promise<RecitalVolunteer> => {
    const response = await baseAPI.patch(
      `/volunteers/${volunteerId}`,
      data
    );
    return response.data;
  },

  // Delete/cancel volunteer signup
  delete: async (volunteerId: string): Promise<void> => {
    await baseAPI.delete(`/volunteers/${volunteerId}`);
  },

  // Get parent's own volunteer signups
  getMySignups: async (recitalId: string): Promise<RecitalVolunteer[]> => {
    const response = await baseAPI.get(
      `/recitals/${recitalId}/volunteers/my-signups`
    );
    return response.data;
  },
};
